/* eslint-disable eqeqeq */
import React, { useContext, useEffect, useState } from "react";
import "./bi.css";
import FilieraContext from "../../contexts/filieraContext";
import { useMsal } from "@azure/msal-react";
import { PermissionsApi } from "../../data/apis/PermissionsApi";
import { apiConfiguration } from "../../apiConfig";
import { LoadPanel } from "devextreme-react/load-panel";

export default function ChiusurePage() {
  const { currentFiliera } = useContext(FilieraContext);
  const [link, setLink] = useState<string>("");
  const [loading, setLoading] = useState(true);

  const { accounts } = useMsal();
  const account = accounts[0];

  useEffect(() => {
    const load = async () => {
      if (!currentFiliera || !account) {
        setLoading(false);
        return;
      }

      // Filiera 4 non richiede controllo permessi
      if (currentFiliera.Id === 4) {
        setLink("https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=87ebd672cdfbbd47bb9f");
        setLoading(false);
        return;
      }

      try {
        const api = new PermissionsApi(apiConfiguration);

        // 1. Recupero tutti i permessi di filiera
        const perms = await api.getFilierePermissions();

        // 2. Filtra solo permessi Progressivi/Chiusure
        const progPerms = perms.filter(p =>
          p.filieraPermissionId?.includes("Filiera/BI/Progressivi")
        );

        // 3. Determina suffisso filiera
        const suffix = currentFiliera.Id === 1
          ? "/01"
          : currentFiliera.Id === 2
          ? "/02"
          : "";

        // 4. Trova permesso Progressivi per la filiera
        const perm = progPerms.find(p =>
          p.filieraPermissionId?.endsWith(suffix)
        );

        if (!perm) {
          setLink("");
          setLoading(false);
          return;
        }

        // 5. Determina ruolo (admin / non admin)
        const isGetione = perm.filieraPermissionId?.includes("/Gestione/");

        // 6. SWITCH CASE link PowerBI
        let selectedLink = "";

        switch (currentFiliera.Id) {
          case 1: // Agricola
            selectedLink = isGetione
              ? "https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectione2b0caef56877181b6ef"
              : "https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSectione2b0caef56877181b6ef";
            break;

          case 2: // Cascina
            selectedLink = isGetione
              ? "https://app.powerbi.com/reportEmbed?reportId=0fd62d51-da98-445b-8d6c-8c3988022c7c&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection62276c450ad757886e57"
              : "https://app.powerbi.com/reportEmbed?reportId=4fd6df77-1631-4d56-af27-5060c85cc561&autoAuth=true&ctid=9a6bb95e-2985-4dfd-b3bf-18638a129013&pageName=ReportSection62276c450ad757886e57";
            break;

          default:
            selectedLink = "";
        }

        setLink(selectedLink);

      } catch (err) {
        console.error("Errore Progressivi/Chiusure:", err);
        setLink("");
      }

      setLoading(false);
    };

    load();
  }, [currentFiliera, account]);

  if (loading) {
    return <LoadPanel visible={true} position={{ of: ".content" }} />;
  }

  return (
    <React.Fragment>
      {link !== "" && (
        <iframe
          title="Report Progressivi/Chiusure"
          src={link}
          className="bi-report-frame"
          allowFullScreen
        />
      )}

      {link === "" && <label>Nessun report per questa filiera</label>}
    </React.Fragment>
  );
}
